import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './AdvantagesBlock.scss';

// @ts-ignore
import Reveal from 'react-reveal/Reveal';

import CONFIG from '../../../config';
import Advantage from '../../Elements/Advantage/Advantage';
import { sendEvent } from '../../../utils';

interface IAdvantagesBlockProps {
  context?: IContent;
}

const shouldAdvantageBeShown = (advantage: any): boolean => {
  if (CONFIG.isUPC) {
    return advantage.upc.image && advantage.upc.description;
  } else {
    return advantage.web.image && advantage.web.description;
  }
};

const AdvantagesBlock = ({ context }: IAdvantagesBlockProps) => {
  const { advantages } = context;

  return (
    <Reveal
      onReveal={() =>
        sendEvent('compare preorder advantages - tab displayed - scroll')
      }
    >
      <div className='block-advantages'>
        <div className='content'>
          <div className='advantage-title'>{advantages.title}</div>
          {advantages.row.map((row: any) =>
            <ul className='advantages'>
              {
                row.list.map(
                  (advantage: any, index: number) =>
                    shouldAdvantageBeShown(advantage) && (
                      <Advantage
                        key={index}
                        info={CONFIG.isUPC ? advantage.upc : advantage.web}
                        index={index}
                      />
                    )
                )
              }
            </ul>
          )}
        </div>
      </div>
    </Reveal>
  );
};

export default withContent(AdvantagesBlock);
